import { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';

import { SEGMENT_COLORS, toNumber } from './npsHelpers';

const styles = {
  bar: {
    display: 'flex',
    overflow: 'hidden',
    width: '100%',
  },
  slice: {
    alignItems: 'center',
    color: '#fff',
    display: 'flex',
    fontWeight: 700,
    justifyContent: 'center',
    minWidth: 0,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
};

// Barra empilhada
function NpsSegmentBar({
  detratores,
  neutros,
  promotores,
  height = 22,
  fontSize = 11,
  radius = 6,
  decimais = 0,
}) {
  const intl = useIntl();
  const ref = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const node = ref.current;

    if (!node || typeof ResizeObserver === 'undefined') return undefined;

    const observer = new ResizeObserver((entries) => {
      setWidth(entries[0]?.contentRect?.width || 0);
    });

    observer.observe(node);

    return () => observer.disconnect();
  }, []);

  const segmentos = [
    {
      key: 'detratores',
      dado: detratores,
      color: SEGMENT_COLORS.detratores,
      label: intl.formatMessage({ id: 'labelDetratores' }),
    },
    {
      key: 'neutros',
      dado: neutros,
      color: SEGMENT_COLORS.neutros,
      label: intl.formatMessage({ id: 'labelNeutros' }),
    },
    {
      key: 'promotores',
      dado: promotores,
      color: SEGMENT_COLORS.promotores,
      label: intl.formatMessage({ id: 'labelPromotores' }),
    },
  ];

  return (
    <div ref={ref} style={{ ...styles.bar, borderRadius: radius, height }}>
      {segmentos.map((segmento) => {
        const percentual = toNumber(segmento.dado?.percentual);

        if (percentual <= 0) return null;

        const texto = `${intl.formatNumber(percentual, {
          maximumFractionDigits: decimais,
        })}%`;
        const larguraSegmento = (percentual / 100) * width;
        // Largura estimada do texto
        const larguraTextoEstimada = texto.length * fontSize * 0.62 + 8;
        const mostrarTexto =
          width > 0 && larguraSegmento >= larguraTextoEstimada;

        return (
          <div
            key={segmento.key}
            style={{
              ...styles.slice,
              backgroundColor: segmento.color,
              flexBasis: `${percentual}%`,
              fontSize,
            }}
            title={`${segmento.label}: ${intl.formatNumber(percentual, {
              maximumFractionDigits: 1,
            })}%`}
          >
            {mostrarTexto ? texto : ''}
          </div>
        );
      })}
    </div>
  );
}

export default NpsSegmentBar;
